<script>
    import certik from 'src/components/main/home/components/audit/certik.svg'

    let link = 'https://www.certik.com/projects/realis?utm_source=SkyEmblem&utm_campaign=realis&utm_medium=link'
</script>

<section>
    <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <a href="{link}" target="_blank">
                    <img src="{certik}" class="audit-image" alt="certik">
                </a>
            </div>
            <div class="col-lg-6">
                <div class="audit-text">
                    <div class="title">On board Certik</div>
                    <div class="description">Our smart contract is audited by leading blockchain security expert Certik. We have taken into account all recommendations so that you can be confident in the security of your transactions.</div>
                    <a href="{link}" class="btn btn-primary" target="_blank"><span>Learn more</span></a>
                </div>
            </div>
        </div>
    </div>
</section>

<style>
    section {
        margin: 250px 0;
        position: relative;
        z-index: 3;
    }

    .audit-image {
        max-width: 100%;
        height: auto;
    }

    .title {
        font-family: 'Anton', sans-serif;
        font-size: 70px;
        font-weight: 400;
        color: white;
        margin: 10px 0 30px;
        line-height: 90px;
    }

    .description {
        color: #CED5E3;
        font-size: 20px;
        margin-bottom: 50px;
        line-height: normal;
    }

    .btn {
        min-width: 290px;
    }

    @media(max-width: 1199px) {
        section {
            margin: 100px 0;
        }

        .title {
            font-size: 50px;
            line-height: 70px;
            margin: 0 0 20px;
        }

        .description {
            margin-bottom: 30px;
        }
    }

    @media (max-width: 992px) {
        .title {
            font-size: 50px;
            line-height: 70px;
            margin: 0 0 30px;
            text-align: center;
        }

        .description {
            text-align: center;
            max-width: 700px;
            margin: 0 auto 30px;
        }

        .audit-image {
            margin: 0 auto 30px;
            display: block;
            max-width: 300px;
        }

        .btn {
            margin: 0 auto;
            display: table;
            min-width: initial;
        }
    }

    @media(max-width: 767px) {
        section {
            margin: 40px 0 60px;
        }

        .title {
            font-size: 40px;
            line-height: 60px;
        }

        .description {
            font-size: 16px;
        }
    }
</style>
